import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "autorio_cookie_ack_v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (localStorage.getItem(STORAGE_KEY) === "1") return;
    } catch (_e) {}
    // small delay so the splash / initial paint finishes first
    const t = setTimeout(() => setVisible(true), 1400);
    return () => clearTimeout(t);
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "1");
    } catch (_e) {}
    setVisible(false);
  };

  const dismiss = () => setVisible(false);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.4, ease: [0.2, 0.8, 0.2, 1] }}
          className="fixed z-[80] inset-x-3 sm:inset-x-4 md:inset-x-6 lg:inset-x-8 bottom-3 sm:bottom-5"
          style={{
            marginBottom: "env(safe-area-inset-bottom, 0)",
          }}
          data-testid="cookie-banner"
        >
          <div className="mx-auto max-w-4xl relative rounded-2xl border border-white/[0.08] bg-[#0a0a0a]/95 backdrop-blur-xl shadow-[0_25px_80px_-15px_rgba(0,0,0,0.9)] overflow-hidden">
            <div
              aria-hidden="true"
              className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/50 to-transparent"
            />
            <div className="p-5 sm:p-6 flex flex-col md:flex-row md:items-center gap-4 md:gap-6">
              <div className="flex items-start gap-4 flex-1 min-w-0">
                <div className="hidden sm:flex h-11 w-11 rounded-xl bg-[#D4AF37]/12 border border-[#D4AF37]/30 items-center justify-center shrink-0">
                  <Cookie
                    className="h-5 w-5 text-[#D4AF37]"
                    strokeWidth={2.2}
                  />
                </div>
                <div className="min-w-0">
                  <div className="text-[10px] font-bold uppercase tracking-[0.22em] text-[#D4AF37]">
                    Cookies
                  </div>
                  <p className="mt-1.5 text-[13px] sm:text-[14px] text-white/75 leading-relaxed">
                    Acest site utilizează cookie-uri pentru funcționarea
                    corectă, analiză și îmbunătățirea experienței de navigare.
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-2.5 md:shrink-0">
                <Link
                  to="/politica-cookie"
                  data-testid="cookie-banner-policy"
                  onClick={dismiss}
                  className="inline-flex items-center justify-center h-11 px-5 rounded-full border border-white/[0.15] text-white/85 hover:text-[#D4AF37] hover:border-[#D4AF37]/50 text-[12px] font-bold uppercase tracking-[0.14em] transition-colors"
                >
                  Politica Cookie
                </Link>
                <button
                  data-testid="cookie-banner-accept"
                  onClick={accept}
                  className="inline-flex items-center justify-center h-11 px-6 rounded-full bg-[#D4AF37] hover:bg-[#e8c86a] text-[#0a0a0a] text-[12px] font-bold uppercase tracking-[0.14em] transition-colors shadow-[0_10px_30px_-8px_rgba(212,175,55,0.5)]"
                >
                  Acceptă
                </button>
              </div>

              <button
                onClick={accept}
                aria-label="Închide"
                className="absolute top-3 right-3 md:hidden h-8 w-8 rounded-full border border-white/[0.1] text-white/60 hover:text-white flex items-center justify-center"
              >
                <X className="h-4 w-4" />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
